import { ConfirmToCreateModal } from './ConfirmToCreateModal'
import { withConfirmToCreateModal } from './withConfirmToCreateModal'

const ConnectedConfirmToCreateModal =
  withConfirmToCreateModal(ConfirmToCreateModal)
export { ConnectedConfirmToCreateModal as ConfirmToCreateModal }
